import React, { useEffect, useState } from 'react'
import { ProductFruits } from 'react-product-fruits'
import { useSelector } from 'src/store/redux.store'

import { isProxyCompany } from 'src/utils/isProxyCompany'
import {
  INTENTION_NAMES_ALLOWED_PRODUCT_FRUIT,
  isExtensionSubscription,
  isSalesProfileUserType,
  isSigupLessThanThirtyDays
} from './product-fruits.utils'
import { PRODUCT_FRUIT_ID, LANG_ISO_2 } from './product-fruits.constants'
import { useExtensionsSubscriptions } from './extensions-subscriptions'
import { IProductFruitsUserProp } from './product-fruits.interfaces'

const RenderProductFruits = () => {
  const { user, context } = useSelector(state => state)

  const userTypeInfo = context?.userTypeInfo
  const isSap = userTypeInfo?.isSap
  const hasIntentionAllowed: boolean = INTENTION_NAMES_ALLOWED_PRODUCT_FRUIT.includes(user?.profile?.intentionName)

  const [productFruitLang, setProductFruitLang] = useState<string>('')
  const [productFruitsUserProp, setProductFruitsUserProp] = useState<IProductFruitsUserProp>()
  const { productFruitsExtensionsSubscriptions } = useExtensionsSubscriptions()

  const {
    email,
    language,
    name,
    isProducerOrSeller,
    productions,
    cluster,
    profile: {
      signupDate,
      lastAccess,
      status,
      hasSale,
      numberOfLogins,
      extensions,
      extensionsFreemium,
      userId,
      intentionName
    }
  } = user

  const proxyCompany = isProxyCompany({
    name,
    email
  })

  useEffect(() => {
    setProductFruitLang(LANG_ISO_2[language] || LANG_ISO_2.EN)
  }, [user])

  useEffect(() => {
    if (productFruitsExtensionsSubscriptions) {
      const productFruitsUserData = {
        username: email,
        props: {
          name,
          firstName: name.split(' ')[0],
          language,
          signupDate,
          lastAccess,
          status,
          numberOfLogins,
          userId,
          intentionName,
          isProducerOrSeller: String(isProducerOrSeller),
          productions: productions.length,
          hasSale: String(hasSale),
          extensions: String(extensions),
          extensionsFreemium: String(extensionsFreemium),
          clusterId: cluster?.clusterId,
          clusterInitials: cluster?.clusterInitials,
          clusterName: cluster?.clusterName,
          proxyEmpresa: String(proxyCompany),
          isSap: String(isSap),
          ...productFruitsExtensionsSubscriptions
        }
      }

      setProductFruitsUserProp(productFruitsUserData)
    }
  }, [productFruitsExtensionsSubscriptions, proxyCompany, isSap])

  const allDatas = productFruitLang && productFruitsUserProp

  const isProxyCompanyAndSignupAllowed = proxyCompany && isSigupLessThanThirtyDays(signupDate)

  const intentionAllowedAndSignupAllowed: boolean = hasIntentionAllowed && isSigupLessThanThirtyDays(signupDate)

  const isRenderProductFruits: boolean =
    isExtensionSubscription(user) ||
    isSalesProfileUserType(userTypeInfo) ||
    intentionAllowedAndSignupAllowed ||
    isProxyCompanyAndSignupAllowed

  return isRenderProductFruits && allDatas ? (
    <div className="_d-none" data-testid="product-fruits-container" id="product-fruits-bw">
      <ProductFruits language={productFruitLang} user={productFruitsUserProp} workspaceCode={PRODUCT_FRUIT_ID} />
    </div>
  ) : null
}

export default RenderProductFruits
